export default "__VITE_ASSET__6d9e87e5__"